import { i18nFn } from '../../../types';
import { CREDIT_LIMIT_ALERT_THRESHOLD } from '../constants';
import { EAlertSeverity, ICreditAlert } from '../subcomponents/score-dashboard/subcomponents/score-result/types';
import { IScoreSummaryResponse } from '../types/api';

export interface DeriveAlertsInput {
  summary: IScoreSummaryResponse | null;
  usagePercent: number;
}

interface AlertRule {
  severity: EAlertSeverity;
  i18nKey: string;
  matches: (input: DeriveAlertsInput) => boolean;
  params?: (input: DeriveAlertsInput) => Record<string, string>;
}

const ALERT_RULES: AlertRule[] = [
  {
    severity: EAlertSeverity.DANGER,
    i18nKey: 'FinBankCreditScoreResult.alerts.latePayment',
    matches: ({ summary }) => Boolean(summary?.latePayment),
  },
  {
    severity: EAlertSeverity.DANGER,
    i18nKey: 'FinBankCreditScoreResult.alerts.increasingDelinquency',
    matches: ({ summary }) => Boolean(summary?.increasingDelinquency),
  },
  {
    severity: EAlertSeverity.WARNING,
    i18nKey: 'FinBankCreditScoreResult.alerts.inactiveCustomer',
    matches: ({ summary }) => Boolean(summary?.inactiveCustomer),
  },
  {
    severity: EAlertSeverity.WARNING,
    i18nKey: 'FinBankCreditScoreResult.alerts.creditLimitNearMax',
    matches: ({ usagePercent }) => usagePercent > CREDIT_LIMIT_ALERT_THRESHOLD,
    params: ({ usagePercent }) => ({ percent: usagePercent.toFixed(0) }),
  },
];

export function deriveAlerts(input: DeriveAlertsInput, i18n: i18nFn): ICreditAlert[] {
  return ALERT_RULES.filter(rule => rule.matches(input)).map(rule => ({
    severity: rule.severity,
    message: i18n(rule.i18nKey, rule.params?.(input)),
  }));
}
